<template>
    <div class="pp-button-expand__wrap">
        <pButton ref="button" type="primary" circle @click="click" :icon="icon"></pButton>
        <transition 
            @enter="enter" 
            @after-enter="after" 
            @leave="enter"
            @after-leave="after">
            <div v-show="showExpand" 
                :class="[
                    'pp-button-expand',
                    `is-${direction}`,
                ]">
                <slot name="expand"></slot>
            </div>
        </transition>
    </div>
</template>

<script>
import pButton from '../../button'

/**
 * 展开按钮
 * @param {String} direction 排列方式['row'(default), 'column']
 */
export default {
    name: 'pp-button-expand',
    components: {
        pButton,
    },
    props: {
        direction: {
            type: String,
            default: 'row',
            validator: function(value) {
                return ['row', 'column'].includes(value);
            },
        },
    },
    data: function() {
        return {
            showExpand: false,
        };
    },
    computed: {
        icon: function() {
            return this.showExpand 
                ? 'pp-icon-menu-square' 
                : 'pp-icon-menu-square-fill';
        },
    },
    methods: {
        click: function(e) {
            this.showExpand = !this.showExpand
        },

        enter: function(el) {
            el.style.transform = `translate3d(100%, 0, 0)`
        },

        after: function(el) {
            el.style.transform = ''
        },
    },
}
</script>

<style>

</style>
